import {HttpCustomService} from "../../service/http-custom.service";
import {AbstractControl, AsyncValidatorFn} from "@angular/forms";
import {Observable, of} from "rxjs";
import {API} from "../apis/api";
import {take} from "rxjs/operators";
import * as _ from "lodash";

export function checkUniqueMeterCode(http: HttpCustomService): AsyncValidatorFn {
  return (control : AbstractControl): Observable<{[key: string]: any}> | null => {
    if (control.parent) {
      const meterCode = control.value;
      const customerNo = control.parent.get("customerNo").value;
      if (meterCode) {
        http.get({path: API.CUSTOMER_METER_CODE_UNIQUE_CHECK}, {'meter-code': meterCode, 'customer-no': customerNo ? customerNo : ''})
          .pipe(take(1))
          .subscribe(data => {
            if (!_.isNil(data) && data) {
              control.setErrors({existedMeterCode: data});
            }
          });
      }
      return of(null);
    }
  }
}
